function init_teacheranim(from_php){
    var main=$(".place.teacheranim");
    var spineResource;
    if(from_php.girl_id==0){
        return false;
    }
    
    var animCanv=main.find("#techearAnim");
    var animArr=[];
    function initView(){
        //anim_max
        var i;
        for(i=1;i<=from_php.anim_max && i<=6;i++){
            main.find(".showGoodJS[data-i='"+i+"']").removeClass("unable");
            animArr.push(i);
        }
        if(from_php.anim_max==7){
             main.find(".showGoodJS[data-i='cum']").removeClass("unable");
        }
        var girl_id,girl_name,html="";
        for(i in from_php.girls_lick){
            girl_id=from_php.girls_lick[i];
            girl_name=$.takeGirlImage(girl_id);
            html+=
            '<div class="cell" data-girl_name="'+girl_name+'">'+
                '<div class="girl"></div>'+
                '<div class="eye"></div>'+
            '</div>';
        }
        main.find("#girlWrapAll").html(html).find(".eye").each(function(){
            $(this).myEye();
        });
    }
    initView();
    if(animArr.length==0){
        return false;
    }
    function prepareRewardBox(){
        var box=main.find("#rewarBox");
        if(box.length==0){
            return false;
        }
        var content=box.find(".contentSelector");
        if(box.find(".iconReward").length>5){
            content.addClass("list");
            box.find(".wrapSelectorJS").myPageSelector({height:92,width:510});
            box.find(".contentSelector").blankCell(0,"iconReward blank");
        }
        else{
            content.addClass("static");
        }
        box.find("#getRewardJS").click(function(){
            box.remove();
            var to_send={page:"gameprogress","event_id":1,give_reward:1};
            $.mypost('/ajax',to_send, function(res) {
                 var data=handleAjaxRes(res);
                 if(typeof data!="undefined" && data){

                 }
             },"json");
        });
    }
    prepareRewardBox();
    function spineBox() {
        PIXI.Container.call(this);
        this.step=0;
        this.step_max=0;
        this.dir=0;
        this.myVal=40;
    };
    spineBox.prototype = Object.create(PIXI.Container.prototype);
    spineBox.prototype= $.extend(spineBox.prototype,{
        myUpdate:function(delta){
            if(this.dir==0){
                return false;
            }
            this.step+=this.dir*delta;
            var alpha=this.step/this.myVal;
            alpha=Math.min(1,alpha);
            alpha=Math.max(0,alpha);
            this.alpha=alpha;
            if(this.step<0 || this.step>this.myVal){
                this.dir=0;
            }
        },
        myShow:function(){
            this.step_max=this.myVal;
            this.step=0;
            this.dir=1;
        },
        myHide:function(){
            this.step_max=0;
            this.dir=-1;
            this.step=this.myVal;
        }
    });
    function spineObj(spineData){
        PIXI.spine.Spine.call(this,spineData);
        this.step=0;
        this.step_max=0;
        this.dir=0;
        this.myVal=40;
    }
    spineObj.prototype = Object.create(PIXI.spine.Spine.prototype);
    spineObj.prototype= $.extend(spineObj.prototype,{
        myUpdate:function(delta){
            if(this.dir==0){
                return false;
            }
            this.step+=this.dir*delta;
            var alpha=this.step/this.myVal;
            alpha=Math.min(1,alpha);
            alpha=Math.max(0,alpha);
            this.alpha=alpha;
            if(this.step<0){
                this.state.setEmptyAnimation(0);
            }
            if(this.step<0 || this.step>this.myVal){
                this.dir=0;
            }
        },
        myShow:function(){
            this.step_max=this.myVal;
            this.step=0;
            this.dir=1;
        },
        myHide:function(){
            this.step_max=0;
            this.dir=-1;
            this.step=this.myVal;
        }
    });
    
    function animTeacher(animCanv,anim_ava){
        if(anim_ava.length==0){
            return false;
        }
        this.anim_conf={
            "1":{y:721,x:460},
            "2":{y:715,x:540},
            "3":{y:712,x:540},
            "4":{y:674,x:565},
            "5":{y:690,x:600},
            "6":{y:790,x:570},
        };
        this.app=new PIXI.Application({
            width: 1280, height: 780,antialias: true,transparent:true,
            view:animCanv[0]
        });
        this.spineArr={};
        this.containerSpine=new spineBox();
        this.state=0;//number or cum;
        this.anim_ava=copyArray(anim_ava);
        this.anim_id=0;
        var app=this.app;
        this.isCum=0;
        this.cumEnded=0;
        this.curSound="";
        this.soundIndex=_moduleTimeHandler.getNewIndex();
        
        var loaderMain = new PIXI.loaders.Loader();
        var i,bum;
        for(i in anim_ava){
            bum=anim_ava[i];
            loaderMain.add("anim_"+bum,_IMG_SERV+"/gfx/place/teacheranim/anim/"+bum+"/skeleton.json");
        }
        loaderMain.load(function(loader, resources){
            spineResource=resources;


            _moduleEvents.one("moduleClear",function(){
                loaderMain.reset();
            });



            animCanv.trigger("was_loaded");

        });
        _moduleEvents.one("moduleClear",function(){
            if(typeof app!="undefined" && app!=null){
                app.destroy();
            }
        });
        return this;
    };
    animTeacher.prototype={
        init:function(){
            var thisObj=this;
            this.main_ticker=this.app.ticker.add(
                function(delta){thisObj.gameLoop(delta);}    
            );
            var i,anim_id,conf;
            
            for(i in this.anim_ava){
                anim_id=this.anim_ava[i];
                this.spineArr[anim_id]=new spineObj(spineResource["anim_"+anim_id].spineData);
                conf=this.anim_conf[anim_id];
                this.spineArr[anim_id].x=conf.x;
                this.spineArr[anim_id].y=conf.y;
                this.spineArr[anim_id].alpha=0;
                
                this.containerSpine.addChild(this.spineArr[anim_id]);
//                this.app.stage
            }
            this.app.stage.addChild(this.containerSpine);
            this.showAnim(this.anim_ava[0]);
            
//            this.showAnim(6);
            
            // run 
            
    
        },
        playSound:function(type_id){
            _moduleTimeHandler.clear(this.soundIndex);
            var type2obj={
                "1":{name:"girl_scared","duration":0},
                "2":{name:"girl_moan","duration":5000},
                "3":{name:"girl_smile","duration":6000},
                "4":{name:"pvpsuck","duration":1000},
                "5":{name:"girl_moan","duration":3000},
                "6":{name:"girl_play","duration":0},
                "cum":{name:"mmoan","duration":0},
                "stop":{name:"","duration":0}
            };
            var nameObj=type2obj[type_id];
            if(this.curSound){
                _mySound.stopSound(this.curSound);
            }
            if(nameObj.name){
                
                var thc=this;
                if(nameObj.duration){
                    _moduleTimeHandler.set(this.soundIndex,function(){
                        thc.curSound=_mySound.playSound(nameObj.name);
                    },nameObj.duration);
                }
                else{
                    this.curSound=_mySound.playSound(nameObj.name);
                }
            }
        },
        gameLoop:function(delta){
            var i,anim_id;
            for(i in this.anim_ava){
                anim_id=this.anim_ava[i];
                this.spineArr[anim_id].myUpdate(delta);
            }
            this.containerSpine.myUpdate(delta);
        },
        showAnim:function(anim_id){
            //getCurrent 
            if(this.anim_id==anim_id && !(this.isCum==1 && anim_id==6)){
//                $.qLog("f ");
                return false;
            }
            if(this.anim_id!==0 && this.anim_id!=anim_id ){
                this.spineArr[this.anim_id].myHide();
            }
            if(this.anim_id!=anim_id){
                this.spineArr[anim_id].myShow();
                
            }
            
            this.spineArr[anim_id].state.clearListeners ();
            if(this.anim_id==anim_id && anim_id==6 && this.cumEnded==0){
                var thc=this;
                this.spineArr[6].state.addListener({
                    complete: function(){
                        thc.spineArr[6].state.setAnimation(0, 'animation', true);
                        thc.playSound(6);
                        thc.spineArr[6].state.clearListeners();
                    }
                });
            }
            else{
                this.spineArr[anim_id].state.clearTracks();
                this.spineArr[anim_id].state.setAnimation(0, 'animation', true);
                this.playSound(anim_id);
            }
            
            this.cumEnded=0;
            this.anim_id=anim_id;
        },
        showCum:function(){
            if(this.anim_id!=6){
                this.spineArr[this.anim_id].myHide();
                this.spineArr[6].myShow();
//                this.spineArr[6].state.clearTracks();
                this.spineArr[6].state.setAnimation(0, 'animation',false);
            }
            else{
                this.spineArr[6].state.clearListeners();
                if(this.cumEnded){
                    this.spineArr[6].state.setAnimation(0, 'animation',false);
                }
            }
            var thc=this;
            var state=0;
            this.spineArr[6].state.addListener({
                complete: function(){
                    
                    state++;
                    if(state==1){
                        thc.playSound("cum");
                        thc.spineArr[6].state.setAnimation(0, 'cum',false);
                    }
                    if(state==2){
                        thc.spineArr[6].state.clearListeners();
                        thc.cumEnded=1;
                    }
                    
                }
            });
            
//            this.spineArr[6].state.addAnimation(1, 'animation',true);
//            this.spineArr[6].state.addAnimation(2,'cum',true);
            this.anim_id=6;
            this.isCum=1;
        },
        showContainer:function(){
            this.containerSpine.myShow();
        },
        hideContainer:function(){
            this.containerSpine.myHide();
        }
    };
    
    
    
    var animObj=new animTeacher(animCanv,animArr);
    animCanv.one("was_loaded",function(){
        animObj.init();
        main.find(".showGoodJS").click(function(){
            var th=$(this),val=th.attr("data-i");
            if(th.is(".unable")){
                main.find(".book[g_id='1']").bookUse("show");
                return false;
            }
            if(val=="cum"){
                animObj.showCum();
            }
            else{
                animObj.showAnim(val);
            }
            
        });
        var anim_show=1;
        main.find("#animToggleTJS").click(function(){
           anim_show=(anim_show+1)%2;
           animObj.playSound("stop");
           if(anim_show==0){
               animObj.hideContainer();
           }
           else{
               animObj.showContainer();
           }
        });
    });
    
    var toHide=$("#mainButtonsBar,#mainBeltRightDownCorner,#ic_premium");
    toHide.css("bottom","-100px");
    _moduleEvents.on("moduleClear",function(){
        toHide.removeAttr("style");
    });
}